import { environment } from './../../../../environment/environment';
import { ApiResponse } from './../../models/response-api';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EsnpermissionService extends CrudService<
  ApiResponse<any>,
  number
> {
  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* create role */
  createRole(body: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + '/api/CompanyRoles/CompanyAddRole',
      body
    );
  }
  /*update role */
  updateRole(body: any, id_role: any): Observable<ApiResponse<any>> {
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/CompanyRoles/update/${id_role}`,
      body
    );
  }

  /*get liste roles */

  getlisteroles(data?: {
    per_page?: number;
    page?: number;
  }) {
   let page=1
   if(data?.page){
    page=data?.page+1
   }
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/CompanyRoles/getRolesByCompanWithPagination?per_page=${data?.per_page}&page=${page}`
    );
  }
  getlisterolesUpdate() {
    return this._http.get<ApiResponse<any>>(
      this._base +
        `/api/CompanyRoles/getRolesByCompanWithPagination`
    );

  }
  /*search list role */
  searchListRole(data: any) {
    if(data.page){
      data.page=data.page+1
    } else{
      data.page=1
    }
    return this._http.post<any>(this._base + `/api/CompanyRoles/search`, data);
  }
  /*delete role  */
  deleterole(id: any): Observable<any> {
    return this._http
      .delete(`${this._base}/api/CompanyRoles/delete/${id}`)
      .pipe(
        map((res: any) => {
          if (res) {
            console.log(res);
            return res;
          }
        })
      );
  }
}
